<template>
  <filter-field label='Application' styles='width: 140px;margin:0 -5px;'
                name='app_id' placeholder='choose app'
                type='select' :list='app_list' :display='display' />
</template>

<script>
export default {
  name: 'filterFieldApplications',
  props: {
    display: Boolean
  },
  computed: {
    app_list () {
      const apps = this.$store.state.apps
      const appsOrdered = _.orderBy(apps, 'name')
      return appsOrdered.map(app => ({id: app.app_id, info: app.name }))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filter/filterFieldApplications.vue